module.exports = __webpack_public_path__ + "img/便携式脚型扫描仪.ec9458b3.png";